import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { $profileFeatureStore, $profileStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { UserInfo, UserInfoHeader } from '@pages/user/widgets';
import { UserOptions } from './widgets';
import { PageContainer, Spinner } from '@shared/widgets';

export const ProfilePage = () => {
  const profileStore = useUnit($profileStore.store);
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const { navigate } = useRouteHook();

  useEffect(() => {
    if (!profileFeatureStore.data?.profileSettings.viewProfile) navigate(RoutePaths.dashboard.onNavigate());
  }, []);

  if (!profileFeatureStore.data?.profileSettings.viewProfile) return null;
  if (!profileStore.data) return null;
  return (
    <PageContainer title='Profile' header='Profile'>
      <div className='flex gap-8 max-[1200px]:flex-col'>
        <UserInfo value={profileStore.data || undefined}>
          {profileStore.loading ? <Spinner /> : <UserInfoHeader user={profileStore.data!} />}
        </UserInfo>
        <UserOptions />
      </div>
    </PageContainer>
  );
};
